import { Link } from 'react-router-dom';

const Footer = ({ message, urls }) => {
   return (
      <footer style={styles.footer}>
         <div style={styles.container}>
            <div style={styles.topSection}>
               <div style={styles.logoSection}>
                  <Link to="/" style={styles.logo}>
                     Yera Kim
                  </Link>
                  <p style={styles.tagline}>Korean Pianist</p>
               </div>

               <div style={styles.linksSection}>
                  <div style={styles.linkGroup}>
                     <h4 style={styles.linkTitle}>Navigate</h4>
                     <Link to="/biography" style={styles.link}>Biography</Link>
                     <Link to="/videos" style={styles.link}>Videos</Link>
                     <Link to="/events" style={styles.link}>Events</Link>
                     <Link to="/contact" style={styles.link}>Contact</Link>
                  </div>

                  <div style={styles.linkGroup}>
                     <h4 style={styles.linkTitle}>Follow</h4>
                     <a
                        href={urls.instagram}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                     >
                        Instagram
                     </a>
                     <a
                        href={urls.youtube}
                        target="_blank"
                        rel="noopener noreferrer"
                        style={styles.link}
                     >
                        YouTube
                     </a>
                  </div>
               </div>
            </div>

            <div style={styles.divider} />

            <div style={styles.bottomSection}>
               <p style={styles.copyright}>{message}</p>
               <div style={styles.socialIcons}>
                  <a
                     href={urls.instagram}
                     target="_blank"
                     rel="noopener noreferrer"
                     style={styles.iconLink}
                     aria-label="Instagram"
                  >
                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <rect x="2" y="2" width="20" height="20" rx="5" />
                        <circle cx="12" cy="12" r="4" />
                        <circle cx="18" cy="6" r="1.5" fill="currentColor" stroke="none" />
                     </svg>
                  </a>
                  <a
                     href={urls.youtube}
                     target="_blank"
                     rel="noopener noreferrer"
                     style={styles.iconLink}
                     aria-label="YouTube"
                  >
                     <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                        <rect x="2" y="4" width="20" height="16" rx="4" />
                        <polygon points="10,8 16,12 10,16" fill="currentColor" stroke="none" />
                     </svg>
                  </a>
               </div>
            </div>
         </div>
      </footer>
   );
};

const styles = {
   footer: {
      backgroundColor: '#0a0a0a',
      color: 'white',
      padding: '80px 0 40px',
   },
   container: {
      maxWidth: '1200px',
      margin: '0 auto',
      padding: '0 5%',
   },
   topSection: {
      display: 'flex',
      justifyContent: 'space-between',
      flexWrap: 'wrap',
      gap: '60px',
      marginBottom: '60px',
   },
   logoSection: {
      flex: '1',
      minWidth: '200px',
   },
   logo: {
      fontFamily: "'Cormorant Garamond', serif",
      fontSize: '1.8rem',
      fontWeight: 500,
      color: 'white',
      textDecoration: 'none',
      letterSpacing: '0.1em',
      display: 'block',
      marginBottom: '10px',
   },
   tagline: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '0.85rem',
      fontWeight: 300,
      color: '#888',
      letterSpacing: '0.1em',
   },
   linksSection: {
      display: 'flex',
      gap: '80px',
      flexWrap: 'wrap',
   },
   linkGroup: {
      display: 'flex',
      flexDirection: 'column',
      gap: '12px',
   },
   linkTitle: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '0.75rem',
      fontWeight: 500,
      letterSpacing: '0.15em',
      textTransform: 'uppercase',
      color: '#c9a227',
      marginBottom: '10px',
   },
   link: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '0.9rem',
      fontWeight: 300,
      color: '#888',
      textDecoration: 'none',
      transition: 'color 0.3s ease',
   },
   divider: {
      height: '1px',
      backgroundColor: '#222',
      marginBottom: '30px',
   },
   bottomSection: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      flexWrap: 'wrap',
      gap: '20px',
   },
   copyright: {
      fontFamily: "'Montserrat', sans-serif",
      fontSize: '0.8rem',
      fontWeight: 300,
      color: '#666',
   },
   socialIcons: {
      display: 'flex',
      gap: '20px',
   },
   iconLink: {
      color: '#888',
      transition: 'color 0.3s ease',
   },
};

export default Footer;
